import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { deltamathAPI } from "../../../manager/utils";
import axios from "axios";
import { deltamathLogo } from "../../../utils";
import Button from "../generic/button";

const LtiError = () => {
  const { ltiId } = useParams();

  // Incase someone has been impersonating, LTI wants to ignore it no matter what
  window.localStorage.removeItem("impersonateStudent");

  const ltiLog = useMutation<{
    data: {
      error: {
        message: string;
        type: "general" | "teacher" | "student";
        code: string;
      };
    };
  }>({
    mutationFn: () => {
      return axios.get(`${deltamathAPI()}/lti/1_3/error/${ltiId}`, {
        params: {
          version: `405`,
          iframe: true,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
  });

  useEffect(() => {
    if (ltiId) {
      ltiLog.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ltiId]);

  const error = ltiLog.data?.data?.error;

  return (
    <div className="flex min-h-screen flex-grow flex-col bg-dm-background-blue-100">
      <div className="flex flex-shrink-0 items-center border-b border-dm-charcoal-100 bg-white px-6 py-3">
        <img
          className="z-2 transition-width max-h-8 duration-300 ease-out"
          src={deltamathLogo}
          alt="DeltaMath Home"
        />
      </div>
      {error ? (
        <div className="mx-auto mt-16 flex max-w-2xl flex-col items-center justify-center px-4">
          <i className="fal fa-exclamation-triangle mb-4 text-4xl text-dm-error-500"></i>
          <h1 className="mb-2 text-2xl font-bold text-black">
            Looks like there&apos;s a problem.
          </h1>
          <p className="mb-2 text-lg font-bold text-black">
            Error {error.code}
          </p>
          <p className="text-normal mb-6">{error.message}</p>
          <Button href="https://help.deltamath.com/" target="_blank">
            Learn how to fix this issue
            <i className="fas fa-arrow-right ml-2" />
          </Button>
        </div>
      ) : (
        <>
          <div className="mx-auto mt-16 flex max-w-2xl flex-col items-center justify-center px-4">
            <i className="fal fa-exclamation-triangle mb-4 text-4xl text-dm-error-500"></i>
            <h1 className="mb-2 text-2xl font-bold text-black">
              Looks like there&apos;s a problem.
            </h1>
            <p className="text-normal mb-6">Please try again.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default LtiError;
